import { AxiosResponse } from 'axios';
import isNil from 'lodash/isNil';

import { APResponse } from '@qality/common-model/src/AP/AP';

import AppPropertiesService from './AppPropertiesService';

const JIRA_SETTINGS_PROPERTY_KEY = 'soldevelo-qality-jira-admin-settings';

export type SettingsProperty = {
  isQalityForNewProjectsEnabled: boolean;
  isPluginForNewProjectsEnabled: boolean;
};

export default {
  async getJiraAdminSettings(): Promise<SettingsProperty> {
    return AppPropertiesService.getAppProperty(JIRA_SETTINGS_PROPERTY_KEY)
      .then((response) => {
        const value = JSON.parse(response.body).value;
        // old users don't have isPluginForNewProjectsEnabled
        // so we set default value - true
        value.isPluginForNewProjectsEnabled = !isNil(
          value.isPluginForNewProjectsEnabled
        )
          ? value.isPluginForNewProjectsEnabled
          : true;
        return value;
      })
      .catch(() => {
        return {
          isQalityForNewProjectsEnabled: true,
          isPluginForNewProjectsEnabled: true,
        };
      });
  },

  setJiraAdminSettings(
    jiraAdminSettings: SettingsProperty
  ): Promise<AxiosResponse | APResponse> {
    return AppPropertiesService.updateAppProperty(
      JIRA_SETTINGS_PROPERTY_KEY,
      jiraAdminSettings
    );
  },
};
